import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import css from '@styled-system/css';
import { Button } from '../components/styled/button';
import { FaCheckCircle, FaRegFrown, FaLaptopCode } from 'react-icons/fa';
import { IoMdTimer } from 'react-icons/io';
import { setPaymentToken } from '../utils/setPaymentToken';
import Countdown from '../components/Countdown';

export default function PaymentConfirmation() {
  const [msgVisible, setMsgVisible] = useState(false)
  const [params, setparams] = useState({});
  const location = useParams();
//   const history = useHistory();
  useEffect(() => {
    setparams(location);
  }, [location]);

  const handleHomeCall = () => {
    // history.push('/');
    // window.location.reload();
    // TO-DO: Go back to original platform & reload on the location
  };

  useEffect(() => {
    const title = window.platform_info.title;
    const token = JSON.parse(localStorage.getItem(`access_token_r_${title}`));
    const refreshTtoken = JSON.parse(localStorage.getItem(`refresh_token_r_${title}`));

    if (params?.status?.toLowerCase().includes('success') && token) {
      setPaymentToken(token, refreshTtoken, title);
    }
  }, [params?.status]);

  return (
    <>
      <Wrapper>
        {params?.status?.toLowerCase().includes('success') && (
          <>
            {!msgVisible && <>
              <Countdown timeLimit={30} setMsgVisible={setMsgVisible} />
              <p>Please wait 30 second after successful payment.</p>
            </>}
            {msgVisible && <>
              <IconClass>
                <FaCheckCircle className={'icon success'} />
              </IconClass>
              <Title>{'Congratulations!'}</Title>
              <Message>You are succesfully subscribed</Message>
              <Button variant="primary" mr="20px" fontSize={18} onClick={handleHomeCall}>
                BACK TO HOME
              </Button>
            </>}
          </>
        )}
        {params?.status?.toLowerCase().includes('fail') && (
          <>
            <IconClass>
              <FaRegFrown className={'icon failed'} />
            </IconClass>
            <Title>{'Subscription failed!'}</Title>
            <Message>Sorry can not proceed with subscription</Message>
          </>
        )}
        {params?.status?.toLowerCase().includes('pending') && (
          <>
            <IconClass>
              <IoMdTimer className={'icon pending'} />
            </IconClass>
            <Title>{'Processing...'}</Title>
            <Message>Your subscription request is processing.</Message>
            <Button variant="primary" mr="20px" fontSize={18} onClick={handleHomeCall}>
              BACK TO HOME
            </Button>
          </>
        )}
        {!params?.status?.toLowerCase().includes('success') &&
          !params?.status?.toLowerCase().includes('fail') &&
          !params?.status?.toLowerCase().includes('pending') && (
            <>
              <IconClass>
                <FaLaptopCode className={'icon generic'} />
              </IconClass>
              <Title>{'Something went wrong!'}</Title>
              <Message>Can not retrieve data</Message>
            </>
          )}
      </Wrapper>
    </>
  );
}

const IconClass = styled.span`
  .icon {
    font-size: 5rem;
    margin-bottom: 24px;
  }
  .success {
    fill: yellowgreen;
  }
  .failed {
    fill: tomato;
  }
  .pending {
    fill: yellowgreen;
  }
  .generic {
    fill: peachpuff;
  }
`;

const Wrapper = styled('div')(
  css({
    textAlign: 'center',
    width: '500px',
    maxWidth: '90%',
    padding: ['1rem', 50],
    borderRadius: 8,
    border: '1px solid rgba(255, 255, 255, 0.13)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--dark-navy-blue)',
    margin: '0 auto',
    marginTop: '50px'
  })
);

const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.33;
  color: var(--white);
`;

const Message = styled.p`
  margin: 18px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.33;
  color: var(--white);
`;
